import React, { FC, ReactNode, ElementType } from 'react'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'
import { Box, makeStyles, Theme } from 'transfix-ui/core'

const ICON_WIDTH = 24
const LABEL_HEIGHT = 20
const SMALL_INPUT_HEIGHT = 32

const useStopInputContainerStyles = makeStyles<Theme, Pick<IStopInputContainerProps, 'hasLabel'>>(
  theme => ({
    iconWrapper: {
      display: 'flex',
      flexGrow: 0,
      marginTop: ({ hasLabel }) => (hasLabel ? LABEL_HEIGHT : 0),
      height: SMALL_INPUT_HEIGHT,
      width: ICON_WIDTH,
      flexBasis: ICON_WIDTH,
      marginRight: theme.spacing(2),
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
    },
  })
)

interface IStopInputContainerProps {
  /**
   * Sets a React component to use for the optional icon component
   * @default 'span'
   */
  IconComponent?: ElementType<ICommonProps>
  /**
   * Sets a className value for icon component
   * @default 'large text-disabled'
   */
  iconClassName?: string
  children: ReactNode
  /**
   * @default true
   */
  hasLabel?: boolean
  /**
   * @default 3
   */
  mb?: number
}

export const StopInputContainer: FC<IStopInputContainerProps> = ({
  IconComponent = 'span',
  children,
  hasLabel = true,
  iconClassName = 'large text-disabled',
  mb: mbProp = 3,
}) => {
  const classes = useStopInputContainerStyles({ hasLabel })
  return (
    <Box mb={mbProp} display='flex' data-test='stop-input-container'>
      <Box className={classes.iconWrapper}>
        <IconComponent className={iconClassName} />
      </Box>
      <Box flexGrow={1}>{children}</Box>
    </Box>
  )
}
